export default __webpack_public_path__ + "static/media/N1.7263a286.png";